import emitter from "@/lib/helpers/emitter";
import { EVENTS } from "@/lib/const";

export default function useLoadingStatus() {
  const setStatus = (status: boolean) => emitter.emit(EVENTS.LOADING.CHANGE, status);

  const loadingStatusShow = (promiseArray: Array<Promise<any>>) => {
    setStatus(true);
    return Promise.all(promiseArray).finally(() => {
      setStatus(false);
    });
  };

  return {
    loadingStatusShow,
    setStatus,
  };
}
